import { Badge, Button, Select, Text } from "@mantine/core";
import {
  JobTaskListSchema,
  JobTaskSchema,
  JobTaskStatus,
} from "@augmodo/lebron-browser-client";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  getTaskStatusColor,
  getTaskStatusText,
} from "@labeling-tools/ui-components/src/utils/helpers";
import { IconArrowLeft, IconArrowRight } from "@tabler/icons-react";

export const AdminToolbar = ({
  jobTasks,
  activeTask,
  headerHeight,
}: {
  jobTasks: JobTaskListSchema;
  activeTask: JobTaskSchema;
  headerHeight: number;
}) => {
  const [searchParams] = useSearchParams();
  const taskId = searchParams.get("taskId");
  const navigate = useNavigate();

  if (!jobTasks?.tasks?.length) {
    return null;
  }

  const currentTaskIndex = jobTasks.tasks.findIndex(
    (task) => task.id === activeTask.id,
  );
  const previousTaskId = jobTasks.tasks[currentTaskIndex - 1]?.id;
  const nextTaskId = jobTasks.tasks[currentTaskIndex + 1]?.id;
  const data = jobTasks.tasks.map((task, index) => ({
    label: `[${index + 1} / ${jobTasks.tasks.length}] ${task.id?.slice(task.id.length - 6)} | ${task.status}`,
    value: task.id as string,
  }));

  return (
    <div
      className="flex flex-row items-center justify-between w-full bg-white border-b border-gray-200 p-4 fixed left-0 right-0 z-10"
      style={{ top: headerHeight, height: headerHeight }}
    >
      <Select
        size="sm"
        className="max-w-sm w-full"
        data={data}
        value={taskId}
        onChange={(value) => {
          if (value) {
            navigate(`${window.location.pathname}?taskId=${value}`);
          }
        }}
      />
      <div className="flex flex-row items-center gap-6">
        <Text size="sm" fw={500} c="gray.7" className="text-left">
          {activeTask.completed_by}
        </Text>
        <Badge
          color={getTaskStatusColor(activeTask.status as JobTaskStatus)}
          variant="light"
          size="sm"
        >
          {getTaskStatusText(activeTask.status as JobTaskStatus)}
        </Badge>

        {/* task navigation */}
        <div className="flex flex-row items-center gap-2">
          <Button
            size="sm"
            variant="outline"
            leftSection={<IconArrowLeft size={16} />}
            disabled={currentTaskIndex === 0}
            onClick={() => {
              navigate(`${window.location.pathname}?taskId=${previousTaskId}`);
            }}
          >
            Back
          </Button>
          <Text size="sm" fw={500} c="gray.7" className="text-left">
            {currentTaskIndex + 1} / {jobTasks.tasks.length}
          </Text>
          <Button
            size="sm"
            variant="outline"
            leftSection={<IconArrowRight size={16} />}
            disabled={currentTaskIndex === jobTasks.tasks.length - 1}
            onClick={() => {
              navigate(`${window.location.pathname}?taskId=${nextTaskId}`);
            }}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};
